var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Crear grupo" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Nombre" },
                                model: {
                                  value: _vm.form.groupName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "groupName", $$v)
                                  },
                                  expression: "form.groupName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.saveGroup }
                                },
                                [_vm._v("Crear")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-row",
                        _vm._l(_vm.groupList, function(item, index) {
                          return _c(
                            "el-col",
                            {
                              key: item.id,
                              attrs: { span: 4, label: item, name: item }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "grid-content bg-purple" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "grid-content bg-purple" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "board-column" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "board-column-header",
                                              style: item.isClose
                                                ? _vm.bgColorGrupoCerrado
                                                : ""
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(item.name) +
                                                  "\n                                        "
                                              ),
                                              _vm._v(" "),
                                              _c("el-button", {
                                                staticStyle: { float: "right" },
                                                attrs: {
                                                  type: item.isClose
                                                    ? "warning"
                                                    : "success",
                                                  icon: item.isClose
                                                    ? "el-icon-setting"
                                                    : "el-icon-check",
                                                  circle: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.generateMatchesGroup(
                                                      item
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              !item.isClose &&
                                              item.teamList.length == 0
                                                ? _c("el-button", {
                                                    staticStyle: {
                                                      float: "right"
                                                    },
                                                    attrs: {
                                                      type: "danger",
                                                      icon: "el-icon-delete",
                                                      circle: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.destroyGroup(item)
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "draggable",
                                            {
                                              staticClass:
                                                "board-column-content",
                                              attrs: {
                                                list: item.teamList,
                                                group: item.isClose
                                                  ? item.id
                                                  : "groups",
                                                id: item.id,
                                                move: _vm.checkMove
                                              },
                                              on: {
                                                moved: _vm.onMoved,
                                                end: _vm.onEnd
                                              }
                                            },
                                            _vm._l(item.teamList, function(
                                              element
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: element.id,
                                                  staticClass: "board-item"
                                                },
                                                [_vm._v(_vm._s(element.name))]
                                              )
                                            })
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 4 } }, [
                    _c("div", { staticClass: "grid-content bg-purple" }, [
                      _c("div", { staticClass: "grid-content bg-purple" }, [
                        _c(
                          "div",
                          { staticClass: "board-column" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "board-column-header",
                                staticStyle: { background: "gray" }
                              },
                              [_vm._v("Equipos sin grupo")]
                            ),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              {
                                staticClass: "board-column-content",
                                attrs: {
                                  list: _vm.teamList,
                                  group: "groups",
                                  move: _vm.checkMove
                                },
                                on: { end: _vm.onEnd, moved: _vm.onMoved }
                              },
                              _vm._l(_vm.teamList, function(element) {
                                return _c(
                                  "div",
                                  {
                                    key: element.id,
                                    staticClass: "board-item",
                                    attrs: { id: element.id }
                                  },
                                  [_vm._v(_vm._s(element.name))]
                                )
                              })
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f9406c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f9406c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/setting-groups/setting-groups.vue
// module id = null
// module chunks = 